// extracted by css-extract-rspack-plugin
export default {"cls1":"Truncate-cls1_HNI","cls2":"Truncate-cls2_Dti Truncate-cls1_HNI"};